import { useEffect, useState } from "react";
import axios from "axios";
import { FaMusic, FaImage, FaFont} from "react-icons/fa";
import {
  useToast,
} from '@chakra-ui/react';

export default function ChartConfig() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [config, setConfig] = useState({
    audioMessageCoins: "",
    videoMessageCoins: "",
    imageMessageCoins: "",
    textMessageCoins: "",
    isActive: false,
  });

  const toast= useToast();

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/v1/app/chart-config");
      if (res.data?.status === "OK" && res.data?.data) {
        setConfig({
          audioMessageCoins: res.data.data.audioMessageCoins ?? "",
          videoMessageCoins: res.data.data.videoMessageCoins ?? "",
          imageMessageCoins: res.data.data.imageMessageCoins ?? "",
          textMessageCoins: res.data.data.textMessageCoins ?? "",
          isActive: !!res.data.data.isActive,
        });
      }
    } catch (err) {
      console.error("Error fetching chart config:", err);
         toast({
        title: "Error loading configuration!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };


  const handleInputChange = (field, value) => {
    const num = value === "" ? "" : parseFloat(value);
    setConfig((p) => ({ ...p, [field]: num }));
  };



  const handleSave = async () => {
    try {
      setSaving(true);
      const payload = {
        audioMessageCoins: Number(config.audioMessageCoins) || 0,
        videoMessageCoins: Number(config.videoMessageCoins) || 0,
        imageMessageCoins: Number(config.imageMessageCoins) || 0,
        textMessageCoins: Number(config.textMessageCoins) || 0,
        isActive: !!config.isActive,
      };

      const res = await axios.put("/api/v1/app/chart-config", payload);

      if (res.data?.status === "OK" && res.data?.data) {
        setConfig({
          audioMessageCoins: res.data.data.audioMessageCoins ?? payload.audioMessageCoins,
          videoMessageCoins: res.data.data.videoMessageCoins ?? payload.videoMessageCoins,
          imageMessageCoins: res.data.data.imageMessageCoins ?? payload.imageMessageCoins,
          textMessageCoins: res.data.data.textMessageCoins ?? payload.textMessageCoins,
          isActive: !!res.data.data.isActive,
        });

         toast({
        title: "Chart configuration updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

       
      } else {
          toast({
        title: "Error saving configuration!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
       
      }
    } catch (err) {
      console.error("Error saving chart config:", err);
       toast({
        title: "Error saving configuration",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
     
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6 max-w-5xl mx-auto bg-[var(--black)] min-h-[160px] flex items-center justify-center">
        <div className="w-8 h-8 rounded-full animate-spin border-4 border-[color:var(--yellow)/0.25] border-t-[var(--yellow)]" />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-5xl mx-auto bg-[var(--black)] text-[var(--yellow)]">
      <h1 className="text-2xl font-bold mb-6 flex items-center gap-2 text-[var(--yellow)]">
        <FaMusic className="text-[var(--yellow)]" /> Chat Configuration
      </h1>

      {message && (
        <div
          className={`mb-6 p-3 rounded-lg text-sm font-medium border-2 ${
            messageType === "error"
              ? "bg-[color:var(--yellow)/0.12] text-[var(--yellow)] border-[var(--yellow)]"
              : "bg-[var(--yellow)] text-[var(--black)] border-[var(--yellow)]"
          }`}
        >
          {message}
        </div>
      )}

      {/* Display Section */}
      <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 mb-8">
        <div className="bg-[var(--black)] border-2 border-[var(--yellow)] rounded-xl p-5">
          <div className="flex items-center gap-3">
            <FaMusic className="text-[var(--yellow)] text-xl" />
            <h3 className="font-semibold text-[var(--yellow)]">Audio Message </h3>
          </div>
          <p className="text-[var(--yellow)] font-bold text-xl mt-2">
            {config.audioMessageCoins} <span className="text-sm font-mono">Coins per Audio</span>
          </p>
        </div>

 

        <div className="bg-[var(--black)] border-2 border-[var(--yellow)] rounded-xl p-5">
          <div className="flex items-center gap-3">
            <FaImage className="text-[var(--yellow)] text-xl" />
            <h3 className="font-semibold text-[var(--yellow)]">Image Message</h3>
          </div>
          <p className="text-[var(--yellow)] font-bold text-xl mt-2">{config.imageMessageCoins} <span className="text-sm font-mono">Coins per Image</span></p>
        </div>

        <div className="bg-[var(--black)] border-2 border-[var(--yellow)] rounded-xl p-5 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3">
              <FaFont className="text-[var(--yellow)] text-xl" />
              <h3 className="font-semibold text-[var(--yellow)]">Text Message</h3>
            </div>
            <p className="text-[var(--yellow)] font-bold text-xl mt-2">{config.textMessageCoins} <span className="text-sm font-mono">Coins per Text</span></p>
          </div>

 
        </div>
      </div>

      {/* Update Section */}
      <div className="bg-[var(--black)] rounded-xl p-6 border-2 border-[var(--yellow)] mb-8">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2 text-[var(--yellow)]">
          Update Chart Values
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Audio Message Coins</label>
            <input
              type="number"
              value={config.audioMessageCoins}
              onChange={(e) => handleInputChange("audioMessageCoins", e.target.value)}
              className="mt-1 w-full border-2 border-[var(--yellow)] rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>



          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Image Message Coins</label>
            <input
              type="number"
              value={config.imageMessageCoins}
              onChange={(e) => handleInputChange("imageMessageCoins", e.target.value)}
              className="mt-1 w-full border-2 border-[var(--yellow)] rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Text Message Coins</label>
            <input
              type="number"
              value={config.textMessageCoins}
              onChange={(e) => handleInputChange("textMessageCoins", e.target.value)}
              className="mt-1 w-full border-2 border-[var(--yellow)] rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>
        </div>

        <div className="mt-4   gap-4">
      

          <button
            onClick={handleSave}
            disabled={saving}
            className="ml-auto px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-[var(--yellow)] text-[var(--black)]"
          >
            {saving ? "Saving..." : "Save Configuration"}
          </button>
        </div>
      </div>
    </div>
  );
}
